export default __webpack_public_path__ + "1ebe8aea91b65ff428a5eaa144d0fa3a.svg";